import axios from 'axios';

// Keeps the person signed in. When the server answers 401 "TOKEN_EXPIRED", the app quietly exchanges the old token for a new one
// (POST /api/auth/refresh) and repeats the failed request, so no "token expired" or "unauthorised" message is ever shown.
// Only a session older than the server's grace period (30 days) fails; then the person is signed out cleanly.
const BASE = `${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api`;
export const SESSION_ENDED_EVENT = 'gettimelam:session-ended';

let refreshing = null; // several requests can fail together; they all wait for one refresh

const refreshToken = () => {
    if (!refreshing) {
        refreshing = axios
            .post(`${BASE}/auth/refresh`, null, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }, __skipRefresh: true })
            .then(res => {
                localStorage.setItem('token', res.data.token);
                return res.data.token;
            })
            .finally(() => { refreshing = null; });
    }
    return refreshing;
};

export const installTokenRefresh = (instance) => {
    instance.interceptors.response.use(
        (response) => response,
        async (error) => {
            const { response, config } = error;
            const expired = response && response.status === 401 && response.data && response.data.code === 'TOKEN_EXPIRED';
            if (!expired || !config || config.__retried || config.__skipRefresh || !localStorage.getItem('token')) throw error;
            try {
                const token = await refreshToken();
                config.__retried = true;
                config.headers = { ...(config.headers || {}), Authorization: `Bearer ${token}` };
                return await instance.request(config);
            } catch (refreshError) {
                // the retry itself may fail for another reason; only a failed refresh ends the session
                if (refreshError && refreshError.config && refreshError.config.__retried) throw refreshError;
                localStorage.removeItem('token');
                window.dispatchEvent(new Event(SESSION_ENDED_EVENT));
                throw error;
            }
        }
    );
};
